import { useMutation } from '@apollo/client';

import { UpdateEventInput } from '../../apollo/__generated__/graphql';
import { UPDATE_EVENT } from '../graphql/mutation/updateEventMutation.graphql';

export const useUpdateEventMutation = (onCompleted?: () => void) => {
  const [mutate] = useMutation(UPDATE_EVENT, { onCompleted });

  const updateEvent = (updateEventInput: UpdateEventInput) => {
    mutate({
      variables: {
        updateEventInput,
      },
    });
  };

  return { updateEvent };
};
